



















































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import Context from "@/mixins/context";
import BrandsStore from "@/mixins/brandsStore";
import AdminBrands from "@/mixins/adminBrands";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes } from "@/data/table";
import { affiliateLinksFilters } from "@/data/filters/affiliate";
import { ConfirmModalModes } from "@/data/enums";

// Types
import { IFilter, ISorter } from "@/models/tables";
import { IAccount } from "@/models/accounts";
import { IClient } from "@/models/clients";

@Component
export default class AffiliateReferralsTable extends Mixins(
  BrandsStore,
  AdminBrands,
  FilteringSortingTableStore,
  Context
) {
  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ default: 5 })
  public declare limit: number;

  // Variables

  public dataModule: string = DataModules.AFFILIATES_REFERRALS;

  public filters: IFilter[] = [
    {
      key: "created_at",
      label: this.$t("_.referral_date"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.referral_date")
    }
  ];

  // Methods

  public async created() {
    if (!this.contentIsAvailable) return;

    this.apiProps = {
      with: "affiliate_account,affiliate_link,client,client.image"
    };
    await this.setFilters();
    this.getData();

    this.$bus.$on("refreshAffiliateReferralsTable", () => {
      this.getData({ ignoreStored: true });
    });
  }

  public setFilters() {
    this.filters = this.$_.concat(
      this.filters,
      affiliateLinksFilters.map(i => ({
        ...i,
        key: `affiliate_link.${i.key}`,
        label: `${this.$t("_.affiliate_link")}: ${i.label}`
      }))
    );
  }

  public async reloadData() {
    this.getData({ ignoreStored: true });
  }

  // overrides mixin method
  public getStoreParams(payload: any): Promise<any> {
    return {
      ...payload,
      accountId: this.accountId
    };
  }

  public confirmDetachReferral(clientId: IClient["id"], affiliateAccountId) {
    this.$store.dispatch("ui/open/confirmModal", {
      config: {
        parent: this,
        props: {
          mode: ConfirmModalModes.BUTTON,
          confirmButtonText: this.$t("_action.unlink_referral"),
          message: this.$t("_sentence.referral_detach_confirmation")
        },
        canCancel: [],
        events: {
          confirmed: async () => {
            this.table.loading = true;
            try {
              await this.detachReferral(clientId, affiliateAccountId);
              this.$emit("reloadData");
              await this.getData({ ignoreStored: true });
              this.$store.dispatch("toast/show", {
                message: this.$t("_.referral_successfully_detached")
              });
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            } finally {
              this.table.loading = false;
            }
          }
        }
      }
    });
  }

  public detachReferral(clientId: IClient["id"], affiliateAccountId) {
    return this.$store.dispatch(
      `data/${DataModules.AFFILIATES_REFERRALS}/detachReferral`,
      {
        clientId,
        affiliateAccountId
      }
    );
  }

  public async openCalculatePrevCommissionsModal(clientId: IClient["id"]) {
    this.$store.dispatch(
      `data/${DataModules.AFFILIATES_REFERRALS}/openCalculatePrevCommissionsModal`,
      {
        props: { clientId },
        events: {
          success: () => {
            this.$emit("reloadData");
          }
        }
      }
    );
  }

  // Computed

  public get canDetachReferral() {
    return this.$userCan("detach_referral");
  }

  public get canCalculateCommissions() {
    return this.$userCan("calculate_previous_commissions");
  }

  // Guarding

  public guardFunctionalities = ["list_affiliate_account_referrals"];

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }

  public beforeDestroy() {
    this.$bus.$off("refreshAffiliateReferralsTable");
  }
}
